import { validateEnumTranslations } from '../../safety_checks';

export enum CalendarSyncProvider {
  GOOGLE = 'GOOGLE',
}

export const CALENDAR_SYNC_PROVIDER_TRANSLATE_KEY = 'CALENDAR_SYNC_PROVIDER_';

export const CalendarSyncProviderTranslation = {
  'fr-FR': {
    [`${CALENDAR_SYNC_PROVIDER_TRANSLATE_KEY}${CalendarSyncProvider.GOOGLE}`]: 'Google Calendar',
  },
};

export enum CalendarSyncDirection {
  BOTH = 'BOTH',
  PROPELSIA_TO_PROVIDER = 'PROPELSIA_TO_PROVIDER',
  PROVIDER_TO_PROPELSIA = 'PROVIDER_TO_PROPELSIA',
}

export const CALENDAR_SYNC_DIRECTION_TRANSLATE_KEY = 'CALENDAR_SYNC_DIRECTION_';

export const CalendarSyncDirectionTranslation = {
  'fr-FR': {
    [`${CALENDAR_SYNC_DIRECTION_TRANSLATE_KEY}${CalendarSyncDirection.BOTH}`]: 'Bidirectionnelle',
    [`${CALENDAR_SYNC_DIRECTION_TRANSLATE_KEY}${CalendarSyncDirection.PROPELSIA_TO_PROVIDER}`]: 'Vers Google Calendar',
    [`${CALENDAR_SYNC_DIRECTION_TRANSLATE_KEY}${CalendarSyncDirection.PROVIDER_TO_PROPELSIA}`]:
      'Depuis Google Calendar',
  },
};

export enum CalendarSyncStatus {
  ACTIVE = 'ACTIVE',
  ERROR = 'ERROR',
  PAUSED = 'PAUSED',
  NEVER_CONNECTED = 'NEVER_CONNECTED',
}

export const CALENDAR_SYNC_STATUS_TRANSLATE_KEY = 'CALENDAR_SYNC_STATUS_';

export const CalendarSyncStatusTranslation = {
  'fr-FR': {
    [`${CALENDAR_SYNC_STATUS_TRANSLATE_KEY}${CalendarSyncStatus.ACTIVE}`]: 'Active',
    [`${CALENDAR_SYNC_STATUS_TRANSLATE_KEY}${CalendarSyncStatus.ERROR}`]: 'En erreur',
    [`${CALENDAR_SYNC_STATUS_TRANSLATE_KEY}${CalendarSyncStatus.PAUSED}`]: 'En pause',
    [`${CALENDAR_SYNC_STATUS_TRANSLATE_KEY}${CalendarSyncStatus.NEVER_CONNECTED}`]: 'Non connectée',
  },
};

export enum CalendarEventSyncStatus {
  PENDING_UPSERT = 'PENDING_UPSERT',
  PENDING_DELETE = 'PENDING_DELETE',
  SYNCED = 'SYNCED',
  ERROR = 'ERROR',
}

export const CALENDAR_EVENT_SYNC_STATUS_TRANSLATE_KEY = 'CALENDAR_EVENT_SYNC_STATUS_';

export const CalendarEventSyncStatusTranslation = {
  'fr-FR': {
    [`${CALENDAR_EVENT_SYNC_STATUS_TRANSLATE_KEY}${CalendarEventSyncStatus.PENDING_UPSERT}`]:
      'En attente de synchronisation',
    [`${CALENDAR_EVENT_SYNC_STATUS_TRANSLATE_KEY}${CalendarEventSyncStatus.PENDING_DELETE}`]:
      'En attente de suppression',
    [`${CALENDAR_EVENT_SYNC_STATUS_TRANSLATE_KEY}${CalendarEventSyncStatus.SYNCED}`]: 'Synchronisé',
    [`${CALENDAR_EVENT_SYNC_STATUS_TRANSLATE_KEY}${CalendarEventSyncStatus.ERROR}`]: 'En erreur',
  },
};

validateEnumTranslations(
  CalendarSyncProvider,
  CalendarSyncProviderTranslation,
  CALENDAR_SYNC_PROVIDER_TRANSLATE_KEY,
  true,
);
validateEnumTranslations(
  CalendarSyncDirection,
  CalendarSyncDirectionTranslation,
  CALENDAR_SYNC_DIRECTION_TRANSLATE_KEY,
  true,
);
validateEnumTranslations(CalendarSyncStatus, CalendarSyncStatusTranslation, CALENDAR_SYNC_STATUS_TRANSLATE_KEY, true);
validateEnumTranslations(
  CalendarEventSyncStatus,
  CalendarEventSyncStatusTranslation,
  CALENDAR_EVENT_SYNC_STATUS_TRANSLATE_KEY,
  true,
);
